import {
    CREATE_GROUP_FAILURE,
    REQUEST_DELETE_GROUP,
    DELETE_GROUP_SUCCESS,
    DELETE_GROUP_FAILURE,
    REQUEST_CUSTOMER_GROUPS_DETAIL,
    FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS,
    FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE,
    REQUEST_CUSTOMER_GROUPS,
    FETCH_CUSTOMER_GROUPS_SUCCESS,
    FETCH_CUSTOMER_GROUPS_FAILURE,
    SAVE_PRODUCT_LIST_SUCCESS,
    SAVE_PRODUCT_LIST_FAILURE,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    isLoading: false,
    error: null,
    groups: [],
    groupsIsLoading: null,
    groupsError: null,
    groupDetails: null,
    groupDetailsIsLoading: false,
    groupDetailsError: false,
    saveProductListSuccess: false,
    saveProductListFailure: false,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Group action handlers
        case CREATE_GROUP_FAILURE:
            const addGroupError = action.payload || { message: action.payload.message };
            return { ...state, error: addGroupError, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case REQUEST_DELETE_GROUP:
            return { ...state, error: null, isLoading: true, saveProductListSuccess: false, saveProductListFailure: false  };
        case DELETE_GROUP_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case DELETE_GROUP_FAILURE:
            const deleteError = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: deleteError, isLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case REQUEST_CUSTOMER_GROUPS_DETAIL:
            return { ...state, groupDetailsError: null, groupDetailsIsLoading: true, saveProductListSuccess: false, saveProductListFailure: false };
        case FETCH_CUSTOMER_GROUPS_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, groupDetails: action.payload.data, groupDetailsError: null, groupDetailsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case FETCH_CUSTOMER_GROUPS_DETAIL_FAILURE:// return error and make loading = false
            const groupDetailsError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], groupDetailsError, groupDetailsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case REQUEST_CUSTOMER_GROUPS:
            return { ...state, groupsError: null, groupsIsLoading: true, saveProductListSuccess: false, saveProductListFailure: false };
        case FETCH_CUSTOMER_GROUPS_SUCCESS:
            return { ...state, groups: action.payload.data, groupsError: null, groupsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case FETCH_CUSTOMER_GROUPS_FAILURE:
            const groupsError = action.payload;
            return { ...state, all: [], groupsError, groupsIsLoading: false, saveProductListSuccess: false, saveProductListFailure: false };
        case SAVE_PRODUCT_LIST_SUCCESS:
            return { ...state, saveProductListSuccess: true };
        case SAVE_PRODUCT_LIST_FAILURE:
            return { ...state, saveProductListError: true };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/groupList_reducer.jsx